import {isNotNil} from 'ramda';

import {
  type MazdaClaimWarrantyType,
  type MazdaPreauthorizationWarrantyType,
} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

const INSTALLATION_WARRANTY_TYPES: readonly string[] = [
  'part_warranty',
  'repeated_repair',
] satisfies readonly (MazdaClaimWarrantyType & MazdaPreauthorizationWarrantyType)[];

export const hasMazdaWarrantyInstallationDetails = (warrantyType: string | Nullish) =>
  isNotNil(warrantyType) && INSTALLATION_WARRANTY_TYPES.includes(warrantyType);
